import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Fragment } from 'react'
import { useAppSelector } from '../../../../store/hooks'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExport } from '@fortawesome/free-solid-svg-icons'

type OutputButtonProps = {
    label: string
    exportTypes: string[]
}

const OutputButton = ({ label, exportTypes }: OutputButtonProps) => {
    const theme = useAppSelector((state) => state.theme.theme)

    return (
        <Dropdown>
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip id="tooltip-export">{label}</Tooltip>
                }
            >
                <Dropdown.Toggle
                    variant={theme === 'dark' ? 'dark' : 'light'}
                    size="sm"
                    aria-label={label}
                    bsPrefix="btn"
                >
                    <FontAwesomeIcon icon={faFileExport} />
                </Dropdown.Toggle>
            </OverlayTrigger>

            <Dropdown.Menu>
                {exportTypes.map((exportType: string, index: number) => (
                    <Fragment key={index}>
                        {(() => {
                            switch (exportType) {
                                case 'xlsx':
                                    return (
                                        <Dropdown.Item href="#/action-1">
                                            Excel Sheet
                                        </Dropdown.Item>
                                    )
                                case 'csv':
                                    return (
                                        <Dropdown.Item href="#/action-1">
                                            CSV
                                        </Dropdown.Item>
                                    )

                                case 'pdf':
                                    return (
                                        <Dropdown.Item href="#/action-1">
                                            PDF
                                        </Dropdown.Item>
                                    )
                                default:
                                    throw new Error('Invalid export type!')
                            }
                        })()}
                    </Fragment>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default OutputButton
